"use client";

import styles from "./styles.module.scss";
import { Faq } from "./FAQ";
import { GrClose } from "react-icons/gr";
import { useMenuStore } from "../../../../store/stores";
import { Header } from "../../../../../veria-nextv1/Header";
import useShowFooter from "../../../../Hooks/useShowFooter";
import useHeaderState from "../../../../Hooks/useHeaderState";
import { Fragment, useEffect, useState } from "react";
import { useCore } from "../../../../../core-nextv3/core/core";
import { ImageSet } from "@/component-nextv3/ImageSet";
import { usePathname } from "next/navigation";
import { Menu } from "./Menu";
import { useAppContext } from "@/veria-nextv1/Providers/app.providers";
import CustomLink from "@/component-nextv3/CustomLink";
import { TopHeader } from "@/veria-nextv1/Views/desktop/compoenents/HeaderDesk/TopHeader";
//import dynamic from "next/dynamic";

declare const document: any;


// const Menu = dynamic(() => import("./Menu").then((mod) => mod.Menu), 
//     {
// 	 ssr : false,
//     });

export const HeaderMobile = () => 
{
    const showFooter                                    = useShowFooter();
    const headerState                                   = useHeaderState();
    const pathname                                      = usePathname();
    const [ isFaqOpen, setIsFaqOpen ]                   = useState<boolean>(false);
    const { cart, user }                                = useCore();
    const { menuData, topHeaderData }                   = useAppContext();
    //const [ isHeaderSearchOpen, setIsHeaderSearchOpen ] = useState<boolean>(false);
    const { toggleMenu, isOpenSearch, toggleFilter, toggleSearch, toggleCart, isOpenMenu, closeMenu } = useMenuStore();

    const pathsFilterProducts: boolean = [ "/produtos", "/colecao/[slug]", "/novidades", "/categoria", "/categoria/[...slug]", "/sale" ].includes(pathname);

    // const toggleCart = useCallback(() => 
    // {
    //     if (isHeaderMenuOpen || isOpenSearch) 
    //     {
    //         toggleCart();
    //         setIsHeaderMenuOpen(false);
    //         return setIsHeaderSearchOpen(false);
    //     }

    //     return toggleCart();

    // }, [ isOpenCart, isHeaderMenuOpen, isOpenSearch ]);

    // const toggleSearch = useCallback(() => 
    // {
    //     if (isHeaderMenuOpen) 
    //     {
    //         setIsHeaderMenuOpen(false);
    //         return toggleSearch();
    //     }

    //     return toggleSearchMenu();
    // }, [ isHeaderMenuOpen, searchMenu ]);

    // const toggleMenu = useCallback(() => 
    // {
    //     if (searchMenu) 
    //     {
    //         toggleSearchMenu();
    //         return setIsHeaderMenuOpen(!isHeaderMenuOpen);
    //     }

    //     return setIsHeaderMenuOpen(!isHeaderMenuOpen);
    // // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [ isHeaderMenuOpen, searchMenu ]);

    useEffect(() => 
    {
        if (isOpenMenu || isOpenSearch) 
        {
            document.body.style.overflow = "hidden";
            document.body.style.position = "fixed";
        }
        else 
        {
            document.body.style.overflow = "auto";
            document.body.style.position = "initial";
        }
    }, [ isOpenMenu, isOpenSearch ]);

    return (
        <Fragment>

            <TopHeader topHeader={topHeaderData}/>

            <Header
                className={`${styles.mainHeader} ${
                    styles[showFooter && headerState ? "sticky" : "transparent"]
                } ${(isOpenMenu || isOpenSearch) && styles.open} header`}
            >
                {/* {hasTopHeader && <>
                    {!cookies.topBarVisible && <header className={styles.topBar}>
                        <div className={styles.content}>
                            <IoMdClose onClick={() => onClose()} />
                            {topHeaderData?.list?.map((item: any, index: any) => (
                                <small key={index}>{item?.name}</small>
                            ))}
                            <BsChevronRight className={styles.arrowRight} />
                        </div>
                    </header>
                    }
                </>} */}

                <div className={styles.content}>
                    <div className={styles.leftTopMobile}>
                        <div
                            onClick={toggleMenu}
                            className={`${styles.headerMenu} ${
                                isOpenMenu && styles.open
                            }`}
                        >
                            <nav className={`${styles.menuBurguer} ${styles.open}`} />
                        </div>

                        {pathsFilterProducts && <ImageSet
                            width={32}
                            height={32}
                            src="/assets/icons/filter.svg"
                            priority
                            alt="Home"
                            responsive={false}
                            onClick={() => toggleFilter()}
                        />}

                        <CustomLink href="/lista-de-desejos/">
                            <ImageSet
                                width={20}
                                height={20}
                                src="/assets/icons/heart.png"
                                responsive={false}
                                alt=""
                            />
                        </CustomLink>

                        <p style={{ width : "20px" }}></p>

                    </div>

                    <CustomLink href="/" onClick={() => 
                    {
                        closeMenu();
                    }}>
                        <ImageSet
                            alt=""
                            className={styles.logo}                        
                            src="/images/logo_black.png"
                            responsive={false}
                        />
                    </CustomLink>
          
                    {/* <Image
            width={980}
            height={166.04}
            src="/images/logo_black.png"
            priority
            alt="Logo"
            className={styles.logo}
            onClick={() => route("/")}
          /> */}
                    <div className={styles.headerNav}>
                        
                        {isOpenSearch ? (
                            <GrClose onClick={toggleSearch} />
                        ) : (
                            <ImageSet
                                width={18}
                                height={18}
                                src="/assets/icons/search.png"
                                priority
                                alt="Pesquisar"
                                responsive={false}
                                onClick={toggleSearch}
                            />
                        )}

                        <CustomLink href={user ? "/perfil/" : "/login/"}>
                            <ImageSet
                                width={18}
                                height={18}
                                src="/assets/icons/user.png"
                                priority
                                alt="User"
                                responsive={false}
                            />
                        </CustomLink>                        

                        <div>
                            <ImageSet
                                width={18} 
                                height={18}
                                src="/assets/icons/cart.png"
                                priority
                                alt="Carrinho"
                                responsive={false}
                                onClick={toggleCart}
                            />
                            <small>{cart?.items?.length || 0}</small>
                        </div>
                    </div>
                </div>
            </Header>
            <Menu        
                isOpen={isOpenMenu}
                closeMenu={closeMenu}
                menu={menuData}
            />
            <Faq isFaqOpen={isFaqOpen} setIsFaqOpen={setIsFaqOpen} />
        </Fragment>
    );
};
